import { Brand } from '../../../types';
import { ESalesContainerV1, ESalesContainerNS } from '../components/ESalesContainer';
import { PersonalizedContainerV1, PersonalizedContainerFC, } from '../components/PersonalizedContainer';
import { RelatedArticlesContainerNS, RelatedArticlesContainerV1, } from '../components/RelatedArticlesContainer';
import { StyleWithContainerV1 } from '../components/StyleWithContainer';
export const getBrandComponent = (componentBase) => {
    const selectedBrand = process.env.BRAND_PREFIX;
    if (componentBase === 'ESalesContainer') {
        if (selectedBrand === Brand.HM)
            return ESalesContainerV1;
        if (selectedBrand === Brand.Northstar)
            return ESalesContainerNS;
    }
    if (componentBase === 'PersonalizedContainer') {
        if (selectedBrand === Brand.HM)
            return PersonalizedContainerV1;
        if (selectedBrand === Brand.Northstar)
            return PersonalizedContainerFC;
    }
    if (componentBase === 'RelatedArticlesContainer') {
        if (selectedBrand === Brand.HM)
            return RelatedArticlesContainerV1;
        if (selectedBrand === Brand.Northstar)
            return RelatedArticlesContainerNS;
    }
    if (componentBase === 'StyleWithContainer' && selectedBrand === Brand.HM)
        return StyleWithContainerV1;
    return null;
};
//# sourceMappingURL=getBrandComponent.js.map